import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('../views/ProductView.vue'),
    },
    {
        path: '/product/productId/:productId',
        name: 'productDetails',
        component: () => import("../views/ProductDetailsView.vue")
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/news/newsId/:newsId',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/edit',
        component: () => import('../views/admin/EditView.vue'),
        children: [
            { path: '', name: 'editIndex', component: () => import('../views/admin/EditIndexView.vue') },
            { path: 'navigation', name: 'editNavigation', component: () => import('../views/admin/EditNavigationView.vue') },
            { path: 'slideshow', name: 'editSlideshow', component: () => import('../views/admin/EditSlideshowView.vue') },
            { path: 'partner', name: 'editPartner', component: () => import('../views/admin/EditPartnerView.vue') },
            { path: 'video', name: 'editVideo', component: () => import('../views/admin/EditVideoView.vue') },
            { path: 'news', name: 'editNews', component: () => import('../views/admin/EditNewsView.vue') },
            { path: 'advantage', name: 'editAdvantage', component: () => import('../views/admin/EditAdvantageView.vue') },
            { path: 'service', name: 'editService', component: () => import('../views/admin/EditServiceModuleView.vue') },
            { path: 'type', name: 'editType', component: () => import('../views/admin/EditTypeView.vue') },
            { path: 'about', name: 'editAbout', component: () => import('../views/admin/EditAboutView.vue') },
            { path: 'section', name: 'editSection', component: () => import('../views/admin/EditSectionView.vue') },
        ]
    }
]

const router = new VueRouter({
    routes
})

export default router
